import { formatDate } from '@/lib/utils';
import { Council } from '@/types';
import apiConfig from '@/config/apiConfig';

interface PayslipDocumentHeaderProps {
  council?: Council | null;
  payPeriod?: string;
  issueDate?: string;
  compact?: boolean;
}

export const PayslipDocumentHeader = ({ 
  council, 
  payPeriod, 
  issueDate,
  compact = false,
}: PayslipDocumentHeaderProps) => {
  // Construct full logo URL by prepending baseUrl to council path
  const getLogoUrl = () => {
    if (!council?.path) return null;
    // If path already starts with http:// or https://, use it as is
    if (council.path.startsWith('http://') || council.path.startsWith('https://')) {
      return council.path;
    }
    // Otherwise, prepend baseUrl
    const baseUrl = apiConfig.baseUrl.replace(/\/$/, ''); // Remove trailing slash if present
    const path = council.path.startsWith('/') ? council.path : `/${council.path}`; // Ensure path starts with /
    return `${baseUrl}${path}`;
  };

  const logoUrl = getLogoUrl();
  

  return (
    <div className={`bg-white border-b border-gray-200 ${compact ? 'p-2 mb-2' : 'p-4 sm:p-6'}`}>
      <div className={`flex flex-col gap-3 sm:flex-row sm:justify-between sm:items-start ${compact ? 'mb-2' : 'mb-4 sm:mb-6'}`}>
        <div className="flex items-center space-x-2 min-w-0">
          {logoUrl ? (
            <div className={`${compact ? 'w-10 h-10' : 'w-12 h-12 sm:w-16 sm:h-16'} rounded flex items-center justify-center overflow-hidden shrink-0`}>
              <img 
                src={logoUrl} 
                alt={council?.name || 'Council Logo'} 
                className="h-full w-full object-contain"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                  const parent = target.parentElement;
                  if (parent) {
                    parent.innerHTML = `<div class="${compact ? 'w-10 h-10 text-sm' : 'w-12 h-12 sm:w-16 sm:h-16 text-lg sm:text-xl'} bg-blue-600 rounded flex items-center justify-center"><span class="text-white font-bold">LC</span></div>`;
                  }
                }}
              />
            </div>
          ) : (
            <div className={`${compact ? 'w-10 h-10' : 'w-12 h-12 sm:w-16 sm:h-16'} bg-blue-600 rounded flex items-center justify-center shrink-0`}>
              <span className={`text-white font-bold ${compact ? 'text-sm' : 'text-lg sm:text-xl'}`}>LC</span>
            </div>
          )}
          <div className="min-w-0">
            <h1 className={`${compact ? 'text-sm' : 'text-lg sm:text-2xl'} font-bold text-gray-900 break-words`}>
              {council?.name || 'Local Council'}
            </h1>
            {!compact && (
              <>
                <p className="text-gray-600 text-sm sm:text-base">Finance Department</p>
                <p className="text-xs sm:text-sm text-gray-500">Ministry of Local Government and Rural Development</p>
              </>
            )}
          </div>
        </div>
        
        <div className="text-left sm:text-right shrink-0">
          <h2 className={`${compact ? 'text-sm' : 'text-lg sm:text-xl'} font-bold text-gray-900`}>PAYSLIP</h2>
          <p className={`${compact ? 'text-[10px]' : 'text-xs sm:text-sm'} text-gray-600`}>Period: {payPeriod || 'N/A'}</p>
          <p className={`${compact ? 'text-[10px]' : 'text-xs sm:text-sm'} text-gray-600`}>
            Issued: {issueDate ? formatDate(issueDate) : 'N/A'}
          </p>
        </div>
      </div>
      
      <div className={`w-full ${compact ? 'h-0.5' : 'h-1'} bg-gradient-to-r from-blue-600 to-blue-400 rounded`}></div>
    </div>
  );
};







